import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap';
import { RequisitionBackwardActionModalComponent } from './requisition-backward-action-modal.component';
import { VoiceInputModule } from 'src/app/shared/ai-assistant/voice-input/voice-input.module';
import { FormalizeCommentModule } from 'src/app/shared/ai-assistant/formalize-comment/formalize-comment.module';
import { ExternalNotesModule } from 'src/app/shared/external-notes/external-notes.module';

@NgModule({
  declarations: [RequisitionBackwardActionModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule.forRoot(),
    VoiceInputModule,
    FormalizeCommentModule,
    ExternalNotesModule
  ],
  exports: [RequisitionBackwardActionModalComponent],
  entryComponents: [RequisitionBackwardActionModalComponent]
})
export class RequisitionBackwardActionModalModule { }
